<template>
  <div>
    <Navbar/>
    <h4>Usuarios</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoUsuario.idUsuario" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoUsuario.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPerfil" name="idPerfil" v-model="datoUsuario.idPerfil">
                      <option v-for="perfil in perfils" :value="perfil.idPerfil" :key="perfil.idPerfil">
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label"> Suscripcion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idSuscripcion" name="idSuscripcion" v-model="datoUsuario.idSuscripcion">
                      <option v-for="suscripcion in suscripcions" :value="suscripcion.idSuscripcion" :key="suscripcion.idSuscripcion">
                        {{ suscripcion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoUsuario.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="clave" class="form-label">Clave</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="clave" name="clave" v-model="datoUsuario.clave" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoUsuario.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoUsuario.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoUsuario.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoUsuario.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="moduloAdministracion" class="form-label">ModuloAdministracion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="moduloAdministracion" name="moduloAdministracion" v-model="datoUsuario.moduloAdministracion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="moduloAtencion" class="form-label">ModuloAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="moduloAtencion" name="moduloAtencion" v-model="datoUsuario.moduloAtencion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="moduloFacturacion" class="form-label">ModuloFacturacion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="moduloFacturacion" name="moduloFacturacion" v-model="datoUsuario.moduloFacturacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="moduloDashboards" class="form-label">ModuloDashboards</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="moduloDashboards" name="moduloDashboards" v-model="datoUsuario.moduloDashboards" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="menuParametros" class="form-label">MenuParametros</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="menuParametros" name="menuParametros" v-model="datoUsuario.menuParametros" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="menuProcesos" class="form-label">MenuProcesos</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="menuProcesos" name="menuProcesos" v-model="datoUsuario.menuProcesos" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="menuReportes" class="form-label">MenuReportes</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="menuReportes" name="menuReportes" v-model="datoUsuario.menuReportes" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="menuAyuda" class="form-label">MenuAyuda</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="menuAyuda" name="menuAyuda" v-model="datoUsuario.menuAyuda" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="opcionConsulta" class="form-label">OpcionConsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="opcionConsulta" name="opcionConsulta" v-model="datoUsuario.opcionConsulta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="opcionOperaciones" class="form-label">OpcionOperaciones</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="opcionOperaciones" name="opcionOperaciones" v-model="datoUsuario.opcionOperaciones" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="opcionDescarga" class="form-label">OpcionDescarga</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="opcionDescarga" name="opcionDescarga" v-model="datoUsuario.opcionDescarga" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="opcionMenu" class="form-label">OpcionMenu</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="opcionMenu" name="opcionMenu" v-model="datoUsuario.opcionMenu" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoUsuario.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarUsuario" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditUsuario" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdBitacoraTra</th>
          <th scope="col">IdTramite</th>
          <th scope="col">IdUsuario</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Observacion</th>
          <th scope="col">Estado</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col">TramiteFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bitacoratra in datosPaginados" :key="bitacoratra.idBitacoraTra">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(bitacoratra.idBitacoraTra)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(bitacoratra.idBitacoraTra)" title="Editar">edit_square</i></td>
          <td>{{bitacoratra.idBitacoraTra}}</td>
          <td>{{bitacoratra.idTramite}}</td>
          <td>{{bitacoratra.idUsuario}}</td>
          <td>{{getFormattedDate(bitacoratra.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{bitacoratra.observacion}}</td>
          <td>{{bitacoratra.estado}}</td>
          <td>{{bitacoratra.usuarioNombre}}</td>
          <td>{{getFormattedDate(bitacoratra.tramiteFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteUsuario(bitacoratra.idBitacoraTra)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idBitacoraTra" class="form-label">IdBitacoraTra</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idBitacoraTra" name="idBitacoraTra" v-model="datoBitacoraTra.idBitacoraTra" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idTramite" class="form-label"> Tramite</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTramite" name="idTramite" v-model="datoBitacoraTra.idTramite">
                      <option v-for="tramite in tramites" :value="tramite.idTramite" :key="tramite.idTramite">
                        {{ tramite.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoBitacoraTra.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoBitacoraTra.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observacion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoBitacoraTra.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarBitacoraTra" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditBitacoraTra" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '../../modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      usuarios : [],
      datoUsuario : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idUsuario: '',
      perfils : [],
      suscripcions : [],
      personas : [],
// Variables master
// Variables details
      bitacoratras : [],
      datoBitacoraTra : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      tramites : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idUsuario = this.$route.params.p_idusuario
    this.abrirEditar(this.p_idUsuario)
    this.getDataPagina(this.paginaActual)
    this.fetchPerfils()
    this.fetchSuscripcions()
    this.fetchPersonas()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idPerfil'
        ,'idSuscripcion'
        ,'nombre'
        ,'clave'
        ,'moduloAdministracion'
        ,'moduloAtencion'
        ,'moduloFacturacion'
        ,'moduloDashboards'
        ,'menuParametros'
        ,'menuProcesos'
        ,'menuReportes'
        ,'menuAyuda'
        ,'opcionConsulta'
        ,'opcionOperaciones'
        ,'opcionDescarga'
        ,'opcionMenu'
        ,'idPersona'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idPerfil'
        ,'idSuscripcion'
        ,'nombre'
        ,'clave'
        ,'moduloAdministracion'
        ,'moduloAtencion'
        ,'moduloFacturacion'
        ,'moduloDashboards'
        ,'menuParametros'
        ,'menuProcesos'
        ,'menuReportes'
        ,'menuAyuda'
        ,'opcionConsulta'
        ,'opcionOperaciones'
        ,'opcionDescarga'
        ,'opcionMenu'
        ,'idPersona'
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async guardarUsuario(){
      if(this.validarForm() === 1){
        try {
          this.datoUsuario.idUsuario = window.sessionStorage.getItem("idUsuario");
          this.datoUsuario.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditUsuario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoUsuario={}
      this.titulo   = 'Crear Usuarios'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idUsuario){
      this.modalWindow = true
      if(idUsuario != null){    
           api.get('/vwusuarios/'+idUsuario).then(resp=>{
          this.datoUsuario = resp.data;
           });
      }
      this.titulo   = 'Editar Usuarios'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarUsuario(){
      this.$router.push('/Usuario')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.bitacoratras.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwbitacoratras/nombre/'+this.nombreBusqueda).then(response=>{
          this.bitacoratras=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.bitacoratras.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwbitacoratras').then(response=>{
      this.bitacoratras=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.bitacoratras.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idPerfil'
        ,'idSuscripcion'
        ,'nombre'
        ,'clave'
        ,'moduloAdministracion'
        ,'moduloAtencion'
        ,'moduloFacturacion'
        ,'moduloDashboards'
        ,'menuParametros'
        ,'menuProcesos'
        ,'menuReportes'
        ,'menuAyuda'
        ,'opcionConsulta'
        ,'opcionOperaciones'
        ,'opcionDescarga'
        ,'opcionMenu'
        ,'idPersona'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idPerfil'
        ,'idSuscripcion'
        ,'nombre'
        ,'clave'
        ,'moduloAdministracion'
        ,'moduloAtencion'
        ,'moduloFacturacion'
        ,'moduloDashboards'
        ,'menuParametros'
        ,'menuProcesos'
        ,'menuReportes'
        ,'menuAyuda'
        ,'opcionConsulta'
        ,'opcionOperaciones'
        ,'opcionDescarga'
        ,'opcionMenu'
        ,'idPersona'
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async guardarBitacoraTra(){
      if(this.validarForm() === 1){
        try {
          this.datoBitacoraTra.idUsuario = this.datoUsuario.idUsuario;
          await api.post('/bitacoratras', this.datoBitacoraTra)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "BitacoraTra creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditBitacoraTra(){
      if(this.validarForm() === 1){
        try {
          await api.post('/bitacoratras', this.datoBitacoraTra)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "BitacoraTra creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoBitacoraTra={}
      this.titulo   = 'Crear Usuarios'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idBitacoraTra){
      this.modalWindow = true
      if(idBitacoraTra != null){    
           api.get('/vwbitacoratras/'+idBitacoraTra).then(resp=>{
          this.datoBitacoraTra = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Usuarios'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idBitacoraTra){
      this.modalWindow = true
      if(idBitacoraTra != null){
        this.$router.push('/bitacoratramd/'+idBitacoraTra)
      }
    },
    async deleteBitacoraTra (idBitacoraTra) {
      try{
        await api.delete('/bitacoratras/'+idBitacoraTra)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPerfils() {
      fetch('http://localhost:8080/api/v1/perfils')
        .then(response => response.json())
        .then(data => {
          this.perfils = data;
        })
        .catch(error => {
          console.error('Error fetching perfils:', error);
        });
    },
    fetchSuscripcions() {
      fetch('http://localhost:8080/api/v1/suscripcions')
        .then(response => response.json())
        .then(data => {
          this.suscripcions = data;
        })
        .catch(error => {
          console.error('Error fetching suscripcions:', error);
        });
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchTramites() {
      fetch('http://localhost:8080/api/v1/tramites')
        .then(response => response.json())
        .then(data => {
          this.tramites = data;
        })
        .catch(error => {
          console.error('Error fetching tramites:', error);
        });
    },
  },
}
</script>
